module.exports = __webpack_public_path__ + "static/img/10.3d514e42.png";